module.exports = __webpack_public_path__ + "img/USA.c09801e2.svg";